const bootstrap = require('bootstrap');
import Flickity from 'flickity';

/**
 * Scroll to page content section when user clicks 'showmore' button in Jumbo section.
 */
function ibaJumboScrollHandler() {
	('use strict');

	const scrollTrigger = document.querySelector('button.showmore');
	const scrollTarget = document.querySelector('section.page-content');

	if (!scrollTrigger || !scrollTarget) {
		return false;
	}

	scrollTrigger.addEventListener(
		'click',
		(e) => {
			scrollTarget.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
				inline: 'nearest',
			});
		},
		{
			passive: true,
		}
	);
}
window.addEventListener('load', ibaJumboScrollHandler, { passive: true });

function ibaQuotesSlider() {
	('use strict');

	const quotesWrapper = document.querySelector('.quotes-wrapper');
	if (!quotesWrapper) {
		return false;
	}

	const flkty = new Flickity(quotesWrapper, {
		// options
		cellAlign: 'center',
		contain: false,
		freeScroll: true,
		wrapAround: true,
		pauseAutoPlayOnHover: false,
		autoPlay: 3500,
		setGallerySize: true,
		pageDots: false
	});
}
window.addEventListener('load', ibaQuotesSlider, { passive: true });

function ibaPrimaryNavigationHandler() {
	('use strict');

	const navigationTriggers = document.querySelectorAll(
		'.menu li a[href*="#"]'
	);
	let navigationTarget = null;

	if (!navigationTriggers) {
		return false;
	}

	for (const navigationTrigger of navigationTriggers) {
		navigationTrigger.addEventListener(
			'click',
			(e) => {
				navigationTarget = navigationTrigger
					.getAttribute('href')
					.substring(1);

				if (
					document
						.querySelector('body')
						.classList.contains('page-template-default')
				) {
					document.location = '/#' + navigationTarget;
				}

				// Hide canvas menu
				if (
					document
						.querySelector('body')
						.classList.contains('canvas--visible')
				) {
					document
						.querySelector('body')
						.classList.remove('canvas--visible');
				}

				// Reset canvas menu button
				if (document.querySelector('.menu-toggle--active')) {
					document
						.querySelector('.menu-toggle--active')
						.classList.remove('menu-toggle--active');
				}
			},
			{
				passive: true,
			}
		);
	}
}
window.addEventListener('load', ibaPrimaryNavigationHandler, { passive: true });

function ibaMenuToggleHandler() {
	('use strict');

	const menuTrigger = document.querySelector('button.menu-toggle');

	if (!menuTrigger) {
		return false;
	}

	menuTrigger.addEventListener(
		'click',
		(e) => {
			menuTrigger.classList.toggle('menu-toggle--active');
			document.querySelector('body').classList.toggle('canvas--visible');
		},
		{
			passive: true,
		}
	);
}
window.addEventListener('load', ibaMenuToggleHandler, { passive: true });

function ibaShowMoreToggler() {
	('use strict');

	function handleIntersect(entries, observer) {
		entries.forEach((entry) => {
			if (true == entry.isIntersecting) {
				document
					.querySelector('body')
					.classList.add('showmore--hidden');
			} else {
				document
					.querySelector('body')
					.classList.remove('showmore--hidden');
			}
		});
	}

	let observer;
	let target = document.querySelector('.showmore');

	if (!target) {
		return false;
	}

	let options = {
		root: null,
		rootMargin: '0px 0px -100px 0px',
		threshold: 1,
	};

	observer = new IntersectionObserver(handleIntersect, options);
	observer.observe(target);
}

window.addEventListener('load', ibaShowMoreToggler, { passive: true });

function ibaInitPopup() {
	('use strict');

	const popupTriggers = document.querySelectorAll('[rel="popup"]');
	const popupContainer = document.querySelector('#popup');
	const popupClose = document.querySelector('#popup .popup-close');

	if (!popupTriggers || !popupContainer) {
		return false;
	}

	console.log(popupTriggers);

	for (const popupTrigger of popupTriggers) {
		popupTrigger.addEventListener('click', (e) => {
			let popupContent = popupTrigger.getAttribute('title');
			popupContainer.querySelector(
				'.popup-content .popup-text'
			).innerHTML = popupContent;
			document.querySelector('body').classList.toggle('popup--visible');
			e.preventDefault();
		});
	}

	popupClose.addEventListener(
		'click',
		(e) => {
			document.querySelector('body').classList.toggle('popup--visible');
		},
		{
			passive: true,
		}
	);
}
window.addEventListener('load', ibaInitPopup, { passive: true });

function ibaInitModals() {
    ('use strict');

	const loginModal = document.getElementById('login-modal');

	if (!loginModal) {
		return;
	}

	loginModal.addEventListener('hidden.bs.modal', function (event) {
		document.location = '/';
	});
	
	loginModal.addEventListener('show.bs.modal', function (event) {
		window.addEventListener(
			'message',
			(event) => {
				if ('number' == typeof event.data.height) {
					document.querySelector('#login-modal iframe').height =
						parseInt(event.data.height) + 'px';
					document
						.querySelector('#login-modal iframe')
						.classList.add('loaded');
				}
			},
			false
		);
	});

}

window.addEventListener('load', ibaInitModals, { passive: true });

function ibafHideLoginModal() {
	('use strict');

	window.addEventListener(
		'message',
		(event) => {
			if (
				'boolean' == typeof event.data.reloadmodal &&
				true == event.data.reloadmodal
			) {
				document.location = '/studieprogramma/';
			}
		},
		false
	);
}
window.addEventListener('load', ibafHideLoginModal, true);

function ibaInitModalTabs() {
	('use strict');

	const tabs = document.querySelectorAll('.tabs-wrapper .tabs li');
	const sections = document.querySelectorAll('.tabs-wrapper .tab-content');

	if ( ! tabs || ! sections ) {
		return;
	}

	tabs.forEach((tab) => {
		tab.addEventListener('click', (e) => {
			e.preventDefault();
			removeActiveTab();
			addActiveTab(tab);
		});
	});

	const removeActiveTab = () => {
		tabs.forEach((tab) => {
			tab.classList.remove('is-active');
		});
		sections.forEach((section) => {
			section.classList.remove('is-active');
		});
	};

	const addActiveTab = (tab) => {
		tab.classList.add('is-active');
		const href = tab.querySelector('a').getAttribute('href');
		const matchingSection = document.querySelector(href);
		matchingSection.classList.add('is-active');
	};

	const tabModals = document.querySelectorAll('.modal--course');
	console.log(tabModals);
	for (const tabModal of tabModals) {
		tabModal.addEventListener('shown.bs.modal', function () {
			if (tabModal.querySelector('nav.tabs li.is-active')) {
				tabModal
					.querySelector('nav.tabs li.is-active')
					.classList.remove('is-active');
			}
			if (tabModal.querySelector('section.tab-content.is-active')) {
				tabModal
					.querySelector('section.tab-content.is-active')
					.classList.remove('is-active');
			}
			tabModal
				.querySelector('nav.tabs li:first-child')
				.classList.add('is-active');
			tabModal
				.querySelector('section.tab-content:first-of-type')
				.classList.add('is-active');
		});		
	}
	
}
window.addEventListener('load', ibaInitModalTabs, true);

function ibaInitTableDescriptions() {
	('use strict');

	const candidateRows = document.querySelectorAll('tr.has-description');

	// Abort if no rows with descriptions are found.
	if (!candidateRows) {
		return;
	}

	for (const row of candidateRows) {
		row.addEventListener(
			'click',
			(e) => {
				row.classList.toggle('show-description');
			}
		);
	}

}
window.addEventListener('load', ibaInitTableDescriptions, true);

function ibaInitProgramDescriptions() {
	('use strict');

	const candidateItems = document.querySelectorAll('.content__component--desc');

	// Abort if no rows with descriptions are found.
	if (!candidateItems) {
		return;
	}

	for (const item of candidateItems) {
		item.addEventListener('click', (e) => {
			item.classList.toggle('visible');
		});
	}
}
window.addEventListener('load', ibaInitProgramDescriptions, true);

function ibaInitProgramLogos() {
	('use strict');

	const logoSliders = document.querySelectorAll('.content__component .logo-slider');

	if (!logoSliders) {
		return;
	}

	for (const logoSlider of logoSliders) {
		let logoFlickity = new Flickity(logoSlider, {
			cellAlign: 'left',
			contain: false,
			prevNextButtons: false,
			pageDots: false,
			wrapAround: true,
			autoPlay: 3500,
		});	
	}
}
window.addEventListener('load', ibaInitProgramLogos, true);